import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Menu, X } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  const navLink = (to, label, testid) => (
    <NavLink
      to={to}
      data-testid={testid}
      className={({ isActive }) =>
        `text-[12px] tracking-[0.16em] uppercase link-underline ${
          isActive ? "text-[#B85C38]" : "text-[#1C1C1C]"
        }`
      }
      onClick={() => setOpen(false)}
    >
      {label}
    </NavLink>
  );

  return (
    <header className="sticky top-0 z-50 glass-header">
      <div className="max-w-[1360px] mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-baseline gap-3">
          <span className="font-serif-display text-[26px] leading-none tracking-tight">Lucid Shelf</span>
          <span className="eyebrow hidden sm:block">Books for a considered life</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLink("/", "Home", "nav-home")}
          {navLink("/catalog", "Catalog", "nav-catalog")}
          {user && navLink("/library", "My Library", "nav-library")}
          {user?.role === "admin" && navLink("/admin", "Admin", "nav-admin")}
          {user ? (
            <button
              onClick={logout}
              data-testid="nav-logout"
              className="text-[12px] tracking-[0.16em] uppercase link-underline"
            >
              Log out
            </button>
          ) : (
            navLink("/login", "Sign in", "nav-login")
          )}
        </nav>

        <button
          className="md:hidden"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#E5E2DC] px-6 py-5 flex flex-col gap-4 bg-[#F9F8F6]">
          {navLink("/", "Home", "mnav-home")}
          {navLink("/catalog", "Catalog", "mnav-catalog")}
          {user && navLink("/library", "My Library", "mnav-library")}
          {user?.role === "admin" && navLink("/admin", "Admin", "mnav-admin")}
          {user ? (
            <button onClick={() => { logout(); setOpen(false); }} data-testid="mnav-logout" className="text-left text-[12px] tracking-[0.16em] uppercase">Log out</button>
          ) : (
            <>
              {navLink("/login", "Sign in", "mnav-login")}
              {navLink("/register", "Join", "mnav-register")}
            </>
          )}
        </div>
      )}
    </header>
  );
}
